import React from "react";
import {connect} from "react-redux";

class inputComponent extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            lang : this.props.lang
        }
    }


    render() {
        return (

            <input className={this.props.className + " "}
                   autoFocus = {this.props.autoFocus}
                   type={this.props.type}
                   placeholder={this.props.placeholder}
                   defaultChecked = {this.props.defaultChecked}
                   onBlur={this.props.blur}
                   onChange={this.props.change}
                   maxLength={this.props.maxlength}
                {...this.props.isvalid}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
    });
};

export const Input = connect ( mapStateToProps ) ( inputComponent );